import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingPhoneButton from './components/FloatingPhoneButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import References from './pages/References';
import Contact from './pages/Contact';
import LegalPage from './pages/LegalPage';

function App() {
  const [contactInfo, setContactInfo] = useState({
    phone: '+90 212 555 0123',
    email: 'info@efruzinsaat.com',
    address: 'Büyükdere Cad. No:125 Esentepe, Şişli, İstanbul'
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || '/public/api';
        const response = await fetch(`${API_BASE}/contact_info.php`);
        if (response.ok) {
          const text = await response.text();
          const result = JSON.parse(text);
          if (result.success && result.data) {
            setContactInfo(result.data);
          }
        }
      } catch (error) {
        console.error('Error fetching contact info:', error);
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/references" element={<References />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
          </Routes>
        </main>
        <Footer contactInfo={contactInfo} />
        <FloatingPhoneButton phoneNumber={contactInfo.phone} />
      </div>
    </BrowserRouter>
  );
}

export default App;
